import React from 'react';

import { useEffect } from 'react';
import { useState } from 'react';
// import { forwardRef } from 'react';
import { useCallback } from 'react';
import moment from 'moment';

import { HomePageService } from '../services/homepage-service';

// import Loading from "../components/layouts/loading";
import GeneralTable from "../components/layouts/general-table";

import TitleGrows from "../components/title-grows";

import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// import IconButton from '@mui/material/IconButton';
// import { withStyles } from '@mui/styles';

export default function HomePages() {

  const cols = [
    { label: 'ID', key: 'id', isSortable: true, isVisible: true, },
    {
      label: 'URI', key: 'uri', isSortable: true, isVisible: true,
      render: (col, row) => {
        return (
          <>
            <Link to={{ pathname: "/homepage/" + row.uri }}>
              {row.uri}
            </Link>
          </>
        );
      }
    },
    { label: 'TITLE', key: 'title', isSortable: false, isVisible: true, },
    {
      label: 'UPDATE',
      key: 'updated',
      isSortable: true,
      isVisible: true,
      render: (col, row) => {
        return moment(row.updated).locale("it").format(`D MMMM YYYY HH:MM`);
      }
    },
    {
      label: '',
      key: 'action',
      isSortable: false,
      isVisible: true,
      render: (col, row) => {
        return (
          <>
            <Link to={{ pathname: "/homepage/" + row.uri }}>
              <FontAwesomeIcon icon={['fas', 'edit']} size={'2x'} color={'#0D6EFD'} title={'Edit'} />
            </Link>
          </>
        );
      }
    },
  ]

  const [isLoading, setIsLoading] = useState(false);

  // let order = true;

  const [pages, setPages] = useState([]);

  const [itemsCount, setItemsCount] = useState(0);
  const [errors, setErrors] = useState([]);

  // let _pageNum = useRef(0)
  // const [pageNum, _setPageNum] = useState(_pageNum.current);
  // const setPageNum = (v) => { _pageNum.current = v; _setPageNum(v) }

  // let _order = useRef({ key: 'id', asc: false })
  // const [order, _setOrder] = useState(_order.current);
  // const setOrder = (v) => { _order.current = v; _setOrder(v) }

  // let _rowsPerPage = useRef(10)
  // const [rowsPerPage, _setRowsPerPage] = useState(_rowsPerPage.current);
  // const setRowsPerPage = (v) => { _rowsPerPage.current = v; _setRowsPerPage(v) }

  const handleChanges = (tableParams) => {
    getData(tableParams)
  };

  const getData = useCallback(async (params = {}) => {

    setIsLoading(true);
    // setPages([])
    // setItemsCount(0)
    const {
      page = 1, page_size = 25, ordering = 'uri'
    } = params
    let _params = {
      page: page,
      page_size: page_size,
      ordering: ordering
    }

    try {
      let resObject = await HomePageService.getList(_params);

      if (!resObject || (resObject?.status && resObject?.status !== 200)) {
        console.log(`Error getList: `, resObject);
        setPages([])
        setItemsCount(0)
        setIsLoading(false);
        setErrors(`Error getList: ${resObject?.statusText} - (status ${resObject?.status})`)
        return {
          revalidate: 5,
          notFound: true,
        }
      }
      if (resObject.count > 0) {
        setItemsCount(resObject.count)
        setPages(resObject.results)
        setIsLoading(false);
      }
      else {
        setErrors(`Nessun risultato trovato!`)
      }
    } catch (e) {
      console.log(e);
      return {
        revalidate: 5,
        notFound: true,
      }
    }
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getData();
    }, 250)
    return () => {
      clearTimeout(delayDebounceFn)
      setIsLoading(false);
      setPages([])
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className='d-flex flex-column h-100'>
      <div className='flex-grow-0'>
        <TitleGrows txtTitle="Homepages" />
      </div>
      {errors.length > 0 ? <div>{errors}</div>
        : <div className='flex-grow-1'>
          <GeneralTable
            cols={cols}
            data={pages}
            itemsCount={itemsCount}
            isLoading={isLoading}
            initialOptions={
              { initialPageSize: 25, initialOrdering: { key: 'uri', asc: true } }
            }
            handleChanges={handleChanges}
          // generalOptions={{ rowsPerPageOptions: [1, 2, 10, 25, 50] }}
          />
        </div>
      }
    </div>
  );
}
